import { type ComponentProps, memo } from 'react';

import { formatDuration } from '@air/utilities';
import { cn } from '@air/utils-tailwind';

import { usePlayerStore } from './PlayerContextProvider';
import {
  PLAYER_PREVIEW_TIMESTAMP_NAME,
  type PlayerPreviewScopeProps,
  usePlayerPreviewContext,
} from './PlayerPreviewContextProvider';

export type PlayerPreviewTimestampProps = Omit<ComponentProps<'time'>, 'children'>;

export const PlayerPreviewTimestamp = memo(
  ({ __scopePlayerPreview, className, ...restOfProps }: PlayerPreviewScopeProps<PlayerPreviewTimestampProps>) => {
    const context = usePlayerPreviewContext(PLAYER_PREVIEW_TIMESTAMP_NAME, __scopePlayerPreview);
    const duration = usePlayerStore((state) => state.duration);

    return (
      <time
        className={cn(
          'absolute bottom-2 left-1/2 flex h-6 -translate-x-1/2 items-center rounded-4 bg-black/60 px-2 text-center font-medium text-12 text-white tabular-nums backdrop-blur',
          className,
        )}
        data-testid="PLAYER_PREVIEW_TIMESTAMP"
        dateTime={formatDuration(context.position * duration)}
        {...restOfProps}
      >
        {formatDuration(context.position * duration)}
      </time>
    );
  },
);

PlayerPreviewTimestamp.displayName = 'PlayerPreviewTimestamp';
